<template>
	<div class="feedPage">
		<brieHeader bag="#fff" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="feedBox">
				<div class="feedLeft">
					<div class="feedItem" @click="btnFn(0)" :class="{ active: flag == 0 }">
						<img src="@/assets/img/fk2.svg" v-show="flag == 1" alt="" />
						<img src="@/assets/img/fk.svg" v-show="flag == 0" alt="" />
						<span>我要反馈</span>
					</div>
					<div class="feedItem" @click="btnFn(1)" :class="flag == 1 ? 'active' : ''">
						<img src="@/assets/img/fkjlu.svg" v-show="flag == 0" alt="" />
						<img src="@/assets/img/fkjl.svg" v-show="flag == 1" alt="" />
						<span>反馈记录</span>
					</div>
				</div>
				<div class="feedRight">
					<feedA v-if="flag == 0" />
					<feedB v-if="flag == 1" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import feedA from '@/page/qTa/feedA';
import feedB from '@/page/qTa/feedB';
import brieHeader from '@/components/hearder/brieHeader';

export default {
	name: 'feedBack',
	data() {
		return {
			flag: 0
		};
	},
	components: {
		brieHeader,
		feedA,
		feedB
	},
	methods: {
		btnFn(type) {
			this.flag = type;
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.feedPage {
	background: #f5f5f5;
	.feedBox {
		min-height: calc(100vh - 60px);
		width: 1200px;
		margin: 0 auto;
		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		.feedLeft {
			width: 140px;
			margin-right: 10px;
			background: #fff;
			padding: 35px 20px 35px 14px;
			box-sizing: border-box;
			height: 164px;
			.feedItem {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 36px;
				cursor: pointer;
				font-size: 16px;
				font-weight: bold;
				&:last-of-type {
					margin-bottom: 0;
				}
				img {
					width: 30px;
					height: 30px;
					margin-right: 8px;
				}
				span {
					color: #333333;
					font-size: 16px;
				}
			}
			.active {
				span {
					color: #1d7b3a;
				}
			}
		}
		.feedRight {
			flex: 1;
			background: #fff;
		}
	}
}
</style>
